import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
/**
 * Return true if the string autorizes html.
 */
export function isStringAuthorizeHtml(str) {
  return /^\[HTML\]/.test(str) && /\[\/HTML\]$/.test(str);
}

/**
 * Wrap string into a pattern that indicates that we authorize HTML in that string.
 * Used by `ErrorMessage` component.
 */
// $FlowFixMe[unclear-type]
export function authorizeHtml(str) {
  if (typeof str === 'string') {
    return "[HTML]".concat(str, "[/HTML]");
  }

  // $FlowFixMe[unclear-type]
  function authorizeHtmlInObject(obj) {
    return _Object$keys(obj).reduce(function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, authorizeHtml(obj[key])));
    }, {});
  }
  return authorizeHtmlInObject(str);
}

/**
 * Remove pattern to retrieve the original string(s).
 */
// $FlowFixMe[unclear-type]
export function unprotectAuthorizedHtml(str) {
  if (typeof str === 'string') {
    return str.replace('[HTML]', '').replace('[/HTML]', '');
  }

  // $FlowFixMe[unclear-type]
  function unprotectAuthorizedHtmlInObject(obj) {
    return _Object$keys(obj).reduce(function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, unprotectAuthorizedHtml(obj[key])));
    }, {});
  }
  return unprotectAuthorizedHtmlInObject(str);
}